import checkIcon from '@assets/icons/check.svg'
import { Modal } from 'antd'
import Image from 'next/image'
import styled from 'styled-components'
import { RockpoolItem } from '../../../types/RockpoolTypes'
import RockPoolCard from '../../shared/cards/RockPoolCard'

interface RockpoolAlreadyExistsModalProps {
  rockpoolItem: RockpoolItem
  onCancel?: () => void
  onSuccess: () => void
}

export const RockpoolAlreadyExistsModal = ({ onCancel, onSuccess, rockpoolItem }: RockpoolAlreadyExistsModalProps) => {
  return (
    <S.Modal destroyOnClose maskClosable visible onCancel={onCancel}>
      <S.Content>
        <S.Message>
          <strong>
            There&apos;s already a public pool for this NFT <Image src={checkIcon} layout='fixed' height={26} width={26} />
          </strong>
          <span>
            You can join in this pool or create
            <br /> a private one for you and your friends.
          </span>
        </S.Message>
        <RockPoolCard item={rockpoolItem} />
        <S.Button onClick={onSuccess}>Create Private Pool</S.Button>
        <S.CancelButton onClick={onCancel}>new search</S.CancelButton>
      </S.Content>
    </S.Modal>
  )
}

const S = {
  Modal: styled(Modal)`
    width: 100% !important;
    max-width: 669px !important;
    .ant-modal-content {
      border-radius: 16px;
      background-color: ${props => props.theme.colors.white};
    }
    .ant-modal-footer {
      display: none;
    }
    .ant-modal-close-x {
      display: none;
    }
    @media (max-width: ${props => props.theme.viewport.tablet}) {
      padding: 10px;
    }
  `,
  Content: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;

    @media (max-width: ${props => props.theme.viewport.tablet}) {
      padding: 24px;
    }
  `,
  Button: styled.button`
    background-color: ${props => props.theme.colors.blue.main};
    border: none;
    border-radius: 8px;
    height: 40px;
    padding: 8px 24px;
    outline: none;
    cursor: pointer;
    color: ${props => props.theme.colors.constants.white};
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;

    &:hover {
      color: ${props => props.theme.colors.constants.white};
    }
  `,
  CancelButton: styled.button`
    background: none;
    border: none;
    color: ${props => props.theme.colors.blue.main};
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;

    &:hover {
      color: ${props => props.theme.colors.blue.dark};
    }
  `,
  Message: styled.span`
    color: ${props => props.theme.colors.black};
    display: flex;
    flex-direction: column;
    align-items: center;
    font-style: normal;
    font-size: 20px;
    line-height: 30px;
    text-align: center;

    > span {
      font-weight: 400;
    }

    > strong {
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  `
}
